module.exports = __webpack_public_path__ + "img/car_icon.804b0633.svg";